"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchResultHits = void 0;
const React = require("react");
const react_instantsearch_1 = require("react-instantsearch");
const SearchResultHitService_1 = require("../../services/SearchResultHitService");
const SearchResultTranslationService_1 = require("../../services/SearchResultTranslationService");
const index_1 = require("../index");
const useSearchResultHits = (selectedTab, tabsResultCountMap, language, isDocumentPage, dictionary) => {
    const { results, status } = (0, react_instantsearch_1.useInstantSearch)();
    const selectedTabKey = selectedTab.key;
    const resultCountFromMap = React.useMemo(() => tabsResultCountMap[selectedTabKey], [tabsResultCountMap, selectedTabKey]);
    const { items } = (0, react_instantsearch_1.useHits)();
    const ids = React.useMemo(() => items.map(hit => hit === null || hit === void 0 ? void 0 : hit.id), [items]);
    const { translations, isContentTranslationLoading } = (0, index_1.usePortfolioContentTranslation)(selectedTab.key, ids, language);
    const { productExtraDataMap, isProductExtraDataLoading } = (0, index_1.useProductExtraData)(selectedTab.key, ids);
    const contentDictionary = React.useMemo(() => {
        return SearchResultTranslationService_1.searchResultTranslationService.transformToContentDictionary(translations, selectedTab);
    }, [translations, selectedTab]);
    const isTabZeroResult = (results === null || results === void 0 ? void 0 : results.nbHits) === 0 && status === 'idle';
    const tiles = React.useMemo(() => {
        if (isTabZeroResult) {
            return [];
        }
        return items.map(hit => {
            const productExtraData = productExtraDataMap[hit === null || hit === void 0 ? void 0 : hit.id];
            return SearchResultHitService_1.searchResultHitService.convertHitToTile(hit, selectedTab.source, dictionary, contentDictionary, productExtraData);
        });
    }, [
        items,
        selectedTab.source,
        dictionary,
        contentDictionary,
        productExtraDataMap,
        isTabZeroResult,
    ]);
    if (isTabZeroResult) {
        return {
            tiles,
            isTabZeroResult: true,
        };
    }
    const resultCount = isDocumentPage
        ? (results === null || results === void 0 ? void 0 : results.nbHits) || 0
        : resultCountFromMap || (results === null || results === void 0 ? void 0 : results.nbHits) || 0;
    return {
        tiles,
        isContentTranslationLoading,
        isProductExtraDataLoading,
        isTabZeroResult: false,
        resultCount,
    };
};
exports.useSearchResultHits = useSearchResultHits;
